import React, { createContext, useContext, useState, useEffect } from 'react';
import { Snackbar, Alert, Slide } from '@mui/material';
import { emitPermissionError } from '../utils/permissionAlertEmitter';

const PermissionAlertContext = createContext();

export const usePermissionAlert = () => {
  const context = useContext(PermissionAlertContext);
  if (!context) {
    throw new Error('usePermissionAlert must be used within PermissionAlertProvider');
  }
  return context;
};

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}

/** Hook dışından aynı Snackbar’ı tetiklemek için: emitPermissionError(backendMessage) */
export {
  emitPermissionError,
  emitPermissionErrorFromResponseData,
} from "../utils/permissionAlertEmitter";

export const PermissionAlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'error',
  });

  // Listen for permission errors from axios interceptors
  useEffect(() => {
    const handlePermissionError = (event) => {
      showAlert(event.detail.message, 'error');
    };

    window.addEventListener('permissionError', handlePermissionError);
    
    return () => {
      window.removeEventListener('permissionError', handlePermissionError);
    };
  }, []);

  const showAlert = (message, severity = 'error') => {
    setAlert({
      open: true,
      message,
      severity,
    });
  };

  const hideAlert = () => {
    setAlert({
      ...alert,
      open: false,
    });
  };

  const showPermissionError = (backendMessage) => {
    emitPermissionError(backendMessage);
  };

  return (
    <PermissionAlertContext.Provider value={{ showAlert, hideAlert, showPermissionError }}>
      {children}
      
      {/* Global Permission Alert Snackbar */}
      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={hideAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={SlideTransition}
        sx={{
          top: { xs: '16px', sm: '24px' },
          zIndex: (theme) => theme.zIndex.snackbar + 100,
          '& .MuiSnackbar-root': {
            top: { xs: '16px', sm: '24px' },
          },
        }}
      >
        <Alert
          onClose={hideAlert}
          severity={alert.severity}
          variant="filled"
          elevation={8}
          sx={{
            width: '100%',
            minWidth: { xs: '280px', sm: '400px' },
            maxWidth: 'min(92vw, 560px)',
            fontSize: '0.95rem',
            fontWeight: 600,
            lineHeight: 1.45,
            borderRadius: 2,
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.35)',
            '& .MuiAlert-icon': {
              fontSize: '26px',
              alignSelf: 'flex-start',
              mt: 0.25,
            },
            '& .MuiAlert-message': {
              py: 0.5,
              wordBreak: 'break-word',
            },
          }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </PermissionAlertContext.Provider>
  );
};







